import { render, staticRenderFns } from "./ComparisonElements.vue?vue&type=template&id=d010787e&"
import script from "./ComparisonElements.vue?vue&type=script&lang=js&"
export * from "./ComparisonElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports